import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { ClassTemplatesByWeekday } from '@/components/admin/class-templates/ClassTemplatesByWeekday';

export default function AdminClassTemplatesPage() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset className="flex-1">
          <div className="p-6">
            <div className="mb-6">
              <h1 className="text-2xl font-bold">ตารางประจำ</h1>
              <p className="text-muted-foreground">
                จัดการตารางเรียนประจำสัปดาห์
              </p>
            </div>
            <ClassTemplatesByWeekday />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
